<template>
  <div class="product-bed-info">
    <div class="bed">
      <div class="bed__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('bed.info.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('bed.info.sub-title')"></span>
          <span class="sub-title__exp">{{$t('bed.info.sub-title-exp')}}</span>
        </div>
      </div>
      <b-row class="bed__image">
        <b-col lg="" class="bed__info">
          <!-- language check -->
          <template v-if="$i18n.locale() === 'ko'">
            <!-- ** lang KO Start ** -->
            <div class="info__item" data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/img_bed_cnn_ko.png" alt="cnn">
              <span>{{$t('bed.info.image1')}}</span>
            </div>
            <!-- ** lang KO End ** -->
          </template>
          <template v-else>
            <!-- ** lang EN Start ** -->
            <div class="info__item" data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/img_bed_cnn_en.png" alt="cnn">
              <span>{{$t('bed.info.image1')}}</span>
            </div>
            <!-- ** lang EN Start ** -->
          </template>
        </b-col>
        <b-col cols="12" lg="auto" class="bed__detail"
               data-aos="fade-up" :data-aos-duration="duration"
               data-aos-delay="300">
          <img src="../../assets/img/img_bed.png" alt="bed"/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { FadeUpMixin } from '../mixins/FadeUp';

export default {
  name: 'BedInfo',
  data() {
    return {
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Product Bed CSS
    ------------------ */
  .product-bed-info {
    @include flexbox;
    @include flex-direction(column);
    align-items: center;
    padding: 122px 40px 135px;
  }

  .bed {
    width: 100%;
    max-width: 1518px;
    @include flexbox;
    @include flex-direction(column);
    flex-shrink: 0;

    &__image {
      margin-top: 20px;
      @include justify-content(center);
      flex-shrink: 0;
    }

    &__info {
      max-width: 357px;
      padding: 0;

      .info__item {
        @include flexbox;
        @include flex-direction(column);
        @include align-items(center);

        & > img {
          width: 70%;
          margin-bottom: 14px;
          flex-shrink: 0;
        }

        & > span {
          width: 70%;
          font-size: 16px;
          line-height: 1.25;
          color: $color-black;
        }

        &:first-of-type {
          margin-bottom: 17px;
        }
      }
    }

    &__detail {
      padding: 0;
      margin-left: auto;
      flex: 0 0 100%;
      text-align: center;
      height: auto;
      & > img {
        max-width: 573px;
        width: 70%;
        flex-shrink: 0;
        position: relative;
        right: 0;
        top: 0;
        z-index: -1;
      }
    }
  }
  @media (min-width: 648px) {
    .bed {
      &__info {
        .info__item {
          @include align-items(start);
          & > img {
            width: 100%;
          }
          & > span {
            width: auto;
          }
        }
      }
      &__image {
        margin-top: 50px;
      }

      &__detail {
        & > img {
          width: 100%;
        }
      }
    }
  }
  @media (min-width: 992px) {
    .product-bed-info {
      padding: 196px 40px 0;
    }
    .bed {
      &__info {
        padding-bottom: 100px;
      }
      &__image {
        @include justify-content(unset);
      }
      &__detail {
        flex: 1;
        text-align: right;

        & > img {
          max-width: 873px;
          top: -20%;
        }
      }
    }
  }

  // IE Only
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .bed__detail {
      & > img {
        top: 0;
      }
    }
    @media (min-width: 992px) {
      .bed__detail {
        & > img {
          top: -150px;
        }
      }
    }
  }
</style>
